@use "../../styles/breakpoint.module.scss" as *;
@use "./Header.module" as *;

.topNav {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: $top-nav-height;

    @media print {
        display: none;
    }
}

.layoutUnset {
    @media ($below-mobile) {
        position: absolute;
        width: 100%;
        visibility: hidden;
        pointer-events: none;
    }

    @media ($above-mobile) {
        opacity: 0;
    }
}

.layoutSet {
    opacity: 1;
}

.links {
    composes: safeContainer from "../../styles/composable/layout.module.css";
    composes: listReset from "../../styles/composable/utility.module.css";
    display: flex;
    align-items: center;
    gap: var(--spacer-24);
    overflow-x: auto;
}

.link {
    font: var(--font-nav-14);
    transform: translateY(-1px);
    white-space: nowrap;
}

.favoritesLink {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;

    .heartIcon {
        width: 16px;
        height: 16px;
        fill: var(--color-contrast);
    }

    &:hover .heartIcon {
        --heart-fill: 75%;
    }

    .heartIconFilled,
    &:hover .heartIconFilled {
        --heart-fill: 100%;
    }
}
